/** @file refitImage: a tile's pixels adapted to a new tile size by Pad (anchored at the pivot) or Scale. */
import { resampleImage } from '@zilo/pose3d-image-io/image/resampleImage';
import type { Image } from '@zilo/pose3d-image-io/types/image';
import type { FitMode } from '../artTypes';
import { padAtPivot } from './padAtPivot';

/** `pad`: `padAtPivot(src, size, offset)`; `scale`: nearest-neighbour resample to `size` (pixel art stays crisp). */
export function refitImage(src: Image, size: readonly [number, number], offset: readonly [number, number], fit: FitMode): Image {
  return fit === 'pad' ? padAtPivot(src, size, offset) : resampleImage(src, size[0], size[1], 'nearest');
}
